import React, { useState, useEffect } from "react"
import RangeSlider from "react-bootstrap-range-slider"
import Button from "react-bootstrap/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

const RangeSliderFilter = ({ searchBy, clearFilter, filterName }) => {
  const [value, setValue] = useState(300)

  useEffect(() => {
    searchBy(filterName, value)
  }, [value])

  const tooltip = () => {
    let time
    if (value >= 60) {
      time = value / 60
      return `${Math.ceil(time)} H`
    }
    return `${value} min`
  }
  return (
    <>
      <div className='filter-container'>
        <p className='myBtn filterBtn w-100'>Prepration time</p>
        <Button
          className='myBtn clear-btn'
          onClick={() => {
            clearFilter("filterName")
            setValue(300)
          }}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </div>
      <RangeSlider
        value={value}
        variant='success'
        tooltipLabel={tooltip}
        max={300}
        min={5}
        step={5}
        onChange={(changeEvent) => setValue(changeEvent.target.value)}
      />
    </>
  )
}
export default RangeSliderFilter
